import React, { memo, useMemo } from 'react';

import { SecondaryButton } from 'components/uiLibrary/LinkButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';

import { SECTIONS, COMPONENTS } from 'components/Globals/Analytics/constants';

import { OUTBOUND_LINK_TYPES, TP } from 'constants/index';

import { createDate } from 'utils/date';

import { currencySymbols } from 'containers/Payment/constants';

import { useTranslation } from 'src/i18n';

import { ENTITY_TYPES } from 'operabase-router/constants';

export const getTicketsURL = (production, { prioritizeWebsiteURL = false, skipDateCheck = false } = {}) => {
  const firstTicketEntry = production?.tickets?.[0];
  const ticketWebsiteKey = prioritizeWebsiteURL ? 'website' : 'boxOfficeWebsite';
  const ticketWebsite = firstTicketEntry?.[ticketWebsiteKey];
  const productionMaxDate = createDate(production?.maxDate);
  const hasTickets =
    (createDate().isSame(productionMaxDate, 'day') || productionMaxDate.isAfter(createDate(), 'day')) &&
    ticketWebsite?.length > 0;

  if (skipDateCheck || hasTickets) {
    return ticketWebsite;
  }

  return null;
};

const TicketButton = ({ production, styles, size, hasLeftIcon = true, trackingData, showTicketPrice = false }) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const { tickets } = production || {};
  const currencySymbol = currencySymbols[tickets?.[0]?.currency?.currency] || '$';
  const ticketUrl = useMemo(() => getTicketsURL(production), [production]);

  if (!ticketUrl) {
    return null;
  }

  const ticketPrice =
    tickets?.[0]?.minTicketPrice && tickets?.[0]?.maxTicketPrice
      ? ` | ${currencySymbol} ${Number(tickets?.[0]?.minTicketPrice)} - ${currencySymbol} ${Number(
          tickets?.[0]?.maxTicketPrice,
        )}`
      : '';

  return (
    <SecondaryButton
      isLink
      external
      externalLinkType={OUTBOUND_LINK_TYPES.TICKET}
      href={ticketUrl}
      rightIcon={<SpriteIcon icon="open_in_new" />}
      leftIcon={hasLeftIcon && <SpriteIcon icon="tickets" />}
      styles={styles}
      size={size}
      trackingData={{
        section: trackingData?.section || SECTIONS.PRODUCTION,
        component: COMPONENTS.TICKET_CTA,
        meta: { ticketUrl, productionId: production?.id },
        entityId: production?.id,
        entityName: production?.name,
        entityType: ENTITY_TYPES.PRODUCTION,
      }}
    >
      {t(`${TP}.FN_TICKETS`)}
      {showTicketPrice ? ticketPrice : null}
    </SecondaryButton>
  );
};

export default memo(TicketButton);
